export default {"src":"/_next/static/media/twitter-slateus.d651d6ac.svg","height":100,"width":100};